export const getAttStatus = () =>
  typeof window !== 'undefined' ? window?.attConsentStatus : undefined;
